import AlertMessage from "./AlertMessage";

export default AlertMessage;
